import { Typography, Divider, Tag } from "antd"

const { Title } = Typography

interface ISettingSectionProps {
  title: string
  children: React.ReactNode | string
  fluid?: boolean
  breadcrumb?: React.ReactNode
  actionButton?: React.ReactNode
  isBeta?: boolean
  classname?: string
}

const SettingSection: React.FC<ISettingSectionProps> = ({
  title,
  children,
  fluid = true,
  breadcrumb,
  actionButton,
  isBeta,
  classname,
}) => {
  const width = fluid ? `w-full` : `lg:w-3/5`
  return (
    <div className={`flex flex-col items-start px-6 xl:px-24 overflow-x-hidden ${classname || ""}`}>
      {!!title && (
        <div className={`w-full mt-8 xl:mt-12 ${width}`}>
          <div className={`flex flex-wrap items-center justify-between`}>
            <div className="flex items-center space-x-2 justify-between">
              <Title level={3} className={"text-left"}>
                {title}
              </Title>
              {isBeta && (
                <Tag className="self-start rounded-full" color="#DBEAFE">
                  <p className="text-black font-semibold ">Beta</p>
                </Tag>
              )}
            </div>
            {!!actionButton && <div>{actionButton}</div>}
          </div>
          {breadcrumb}
          <Divider className="my-4" />
        </div>
      )}
      {children}
    </div>
  )
}

export default SettingSection
